<template>
  <div>
    <a-card hoverable :body-style="{ padding: '20px 25px 20px' }" style="border-radius: 8px">
      <a-page-header v-if="dataSource" style="padding: 0px">
        <template slot="title">
          <a style="max-width: 225px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #252525; font-size: 18px" target="_blank" :href="link">{{ dataSource.title || '--' }}</a>
        </template>
        <template slot="subTitle">
          <div>
            <div style="white-space: nowrap">
              <span>{{ `产研需求 # PR-${dataSource.id}` }}</span>
              <a-progress style="max-width: 120px; margin-left: 10px" :percent="dataSourceProgress" />
            </div>
          </div>
        </template>
        <template slot="extra" />
        <a-descriptions :column="3">
          <a-descriptions-item label="状态">
            <a-badge v-if="dataSource.status" style="margin-top: 5px" :status="storyStatus[dataSource.status].status" :text="storyStatus[dataSource.status].label" />
          </a-descriptions-item>
          <a-descriptions-item label="任务数">
            <span> {{ dataSource.progress ? dataSource.progress.count || 0 : 0 }}个({{ dataSource.progress ? dataSource.progress.total || 0 : 0 }}任务点) </span>
          </a-descriptions-item>
          <a-descriptions-item label="是否拆分完成">
            <span>
              {{ dataSource.split_done == 0 ? '否' : '是' }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="评审时间">
            <span>
              {{ dataSource.is_review }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="产品">
            <span v-if="dataSource.pm && dataSource.pm.length > 0">
              <span v-for="user in dataSource.pm" :key="user.id">
                <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
              </span>
            </span>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="负责人">
            <span v-if="dataSource.handlers && dataSource.handlers.length > 0">
              <span v-for="(user, idx) in dataSource.handlers" :key="idx">
                <template v-if="user && user != null">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </template>
              </span>
            </span>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="最晚完成时间">
            <span>
              {{ dataSource.end_time || '--' }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </a-card>
  </div>
</template>

<script>
import { storyStatus } from '@/utils/dictionary';
export default {
  components: {},
  props: {
    dataSource: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      storyStatus
    };
  },
  computed: {
    users() {
      return items => {
        return items || [];
      };
    },
    dataSourceProgress() {
      return this.dataSource.progress ? this.dataSource.progress.progress : 0;
    },
    link() {
      return this.$router.resolve({
        name: 'page:project:story:detail',
        params: { project_id: this.dataSource.project ? this.dataSource.project.id || 0 : 0 },
        query: { storyId: this.dataSource.id || 0 }
      }).href;
    }
  },
  methods: {
    onSubmit() {}
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-page-header-heading-title {
  max-width: 270px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
</style>
